import apiClient from './apiClient';

/**
 * Dashboard API Services
 */

// Get dashboard stats
export const getDashboardStats = async (period = 'this-month') => {
  const response = await apiClient.get('/industryConnect/hr/dashboard/stats', { 
    params: { period } 
  });
  return response.data;
};

// Get college wise hiring data
export const getCollegeHiringData = async (period = 'this-month', limit = 10) => {
  const response = await apiClient.get('/industryConnect/hr/dashboard/college-hiring', { 
    params: { period, limit } 
  });
  return response.data;
};

// Get apprenticeship vs OJT comparison
export const getApprenticeshipOJTComparison = async (period = 'this-month') => {
  const response = await apiClient.get('/industryConnect/hr/dashboard/apprenticeship-ojt-comparison', { 
    params: { period } 
  });
  return response.data;
};

// Get recent activities
export const getRecentActivities = async (limit = 10) => {
  const response = await apiClient.get('/industryConnect/hr/dashboard/recent-activities', { 
    params: { limit } 
  });
  return response.data;
};
